module.exports = __webpack_public_path__ + "img/Ministry_of_Trade_of_Iraq.bc6d2430.png";